<template>
  <v-container>
    <div class="back-nav">
      <v-btn v-if="previousRouteName" text @click="goBack">
        <v-icon left>mdi-chevron-left</v-icon>
        {{ previousRouteName }}
      </v-btn>
    </div>
    <div class="header">
      <h2>
        {{ this.checklistItem.name }}
      </h2>
    </div>
    <v-row>
      <v-col cols="12" md="8">
        <component
          :is="renderer"
          :checklist-item="checklistItem"
          @reset="reset"
          @complete="save(true)"
          @finish-later="save(false)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EvdCurrent from "@/components/EvdCurrent";
import POMForm from "@/components/POMForm";
import { get, put } from "@/services/request";
import {
  customerChecklistByIdAPI,
  customerEvdChecklistByIdAPI
} from "@/services/api";
import cloneDeep from "lodash/cloneDeep";
import hasNotifications from "@/mixins/has-notifications";

var previousRouteName;

export default {
  name: "ChecklistItem",
  mixins: [hasNotifications],
  props: ["customerId", "itemId"],
  created() {
    this.previousRouteName = previousRouteName;
    this.loadData();
  },
  data: () => ({
    checklistItem: {}
  }),
  computed: {
    isEVD() {
      return this.checklistItem && this.checklistItem.type === "EVD";
    },
    isPOM() {
      return this.checklistItem && this.checklistItem.type === "MONTHLY_POM";
    },
    renderer() {
      if (this.isEVD) return EvdCurrent;
      else if (this.isPOM) return POMForm;
      return null;
    }
  },
  methods: {
    loadData() {
      get(
        customerChecklistByIdAPI.getUrl({
          customerId: this.customerId,
          checklistItemId: this.itemId
        })
      ).then(response => this.handleResponse(response));
    },
    reset() {
      this.checklistItem = cloneDeep(this.lastChecklistItem);
    },
    save(markComplete) {
      const API = this.isEVD
        ? customerEvdChecklistByIdAPI
        : customerChecklistByIdAPI;

      put(
        API.getUrl({
          customerId: this.customerId,
          checklistItemId: this.itemId,
          markComplete: markComplete
        }),
        this.checklistItem
      )
        .then(() => {
          this.goBack();
        })
        .catch(() =>
          this.showMessage({ text: "Failed to save form", mode: "error" })
        );
    },
    handleResponse(response) {
      if (response && response.data) {
        this.checklistItem = response.data;
        this.lastChecklistItem = cloneDeep(response.data);
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  beforeRouteEnter: (to, from, next) => {
    if (from.meta && from.meta.humanName) {
      previousRouteName = from.meta.humanName;
    } else {
      previousRouteName = from.name;
    }

    next();
  }
};
</script>

<style lang="sass" scoped>
.v-btn
  text-transform: none
  font-weight: bold
  letter-spacing: unset
  text-indent: unset
  font-size: 1rem

.v-btn.v-btn--text
  font-weight: normal
  color: $subtitle

h1
  font-size: 40px
  line-height: 50px
  color: $darker-grey

h2
  font-size: 35px
  line-height: 44px
  color: $darker-grey

h3
  font-size: 24px
  font-weight: normal
  line-height: 31px
  color: $darker-grey
</style>
